export const GET_BANK_DETAILS = "GET_BANK_DETAILS";
export const GET_BANK_DETAILS_FOR_USER = "GET_BANK_DETAILS_FOR_USER";
export const SET_BANK_DETAILS = "SET_BANK_DETAILS";
export const SET_BANK_DETAILS_FOR_USER = "SET_BANK_DETAILS_FOR_USER";

export const ADD_BANK_DETAILS = "ADD_BANK_DETAILS";
export const UPDATE_BANK_DETAILS = "UPDATE_BANK_DETAILS";
export const DELETE_BANK_DETAILS = "DELETE_BANK_DETAILS";

export const BANK_DETAILS_LOADING = "BANK_DETAILS_LOADING";
